"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaAssetProperty = exports.ctaAssetPropertyDefinition = void 0;
exports.ctaAssetPropertyDefinition = {
    view: { label: 'CTA asset' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'cta-action-type',
                'cta-button-label',
                'cta-asset-link',
                'cta-start-date',
                'cta-end-date',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'cta-asset',
};
const isCtaAssetProperty = (prop) => {
    return prop.name === exports.ctaAssetPropertyDefinition.name;
};
exports.isCtaAssetProperty = isCtaAssetProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLWFzc2V0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY3RhLWFzc2V0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRTtJQUM1QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFO2dCQUNSLGlCQUFpQjtnQkFDakIsa0JBQWtCO2dCQUNsQixnQkFBZ0I7Z0JBQ2hCLGdCQUFnQjtnQkFDaEIsY0FBYzthQUNmO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsV0FBVztDQUNjLENBQUE7QUFJMUIsTUFBTSxrQkFBa0IsR0FBRyxDQUFDLElBQWtCLEVBQTRCLEVBQUU7SUFDakYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtDQUEwQixDQUFDLElBQUksQ0FBQTtBQUN0RCxDQUFDLENBQUE7QUFGWSxRQUFBLGtCQUFrQixzQkFFOUIifQ==